import {gql} from '@apollo/client';

import {QueryResultType, useBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {AllRequestTemplatesQuery} from './__generated/AllRequestTemplatesQuery';

export const ALL_REQUEST_TEMPLATES_QUERY = gql`
  query AllRequestTemplatesQuery @skipAudit @engComponent(name: REQUESTS) {
    ...AllRequestTemplatesGraphQL
  }
  ${getFragmentWrapper('AllRequestTemplates').fragment}
`;

export default function useAllRequestTemplatesQuery(): Array<RequestTemplateGraphQL> | null {
  const result = useBenchlingQuery<AllRequestTemplatesQuery>(ALL_REQUEST_TEMPLATES_QUERY);
  return result.type === QueryResultType.SUCCESS ? result.data.requestTemplates : null;
}
